import React, { useState } from 'react';
import axios from '../axios';

const SectionLowerBanners = ({ onSelectPlace, prefId }) => {
  const [places, setPlaces] = useState([]);

  React.useEffect(() => {
    axios.get('/api/places', { params: { place_category_id: 11, ...(prefId && { pref_id: prefId })}})
      .then((res) => setPlaces(res.data))
      .catch(() => {});
  }, [prefId]);

  if (!places.length) return null;

  return (
    <div className="container col-md-8 col-lg-6 p-0 mb-2">
      <div className="d-flex overflow-auto">
        {places.map((place) => (
          <div 
            key={place.id}
            style={{ width: '130px', flex: '0 0 auto' }}
            className="ml-2"
            onClick={() => onSelectPlace && onSelectPlace(place.id)}
            role="button"
          >
            <div style={{ position: 'relative', paddingBottom: '100%', borderRadius: '8px',overflow: 'hidden' }}>
              <img src={place.image_data_medium || place.image_data || '/assets2019/img/icon_camera.svg'}
                alt={place.name}
                style={{ position: 'absolute',width: '100%', height: '100%',objectFit: 'cover' }}
              />
            </div>
            <p className="mt-2 mb-2 font-weight-bold"
              style={{ fontSize: '13px', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
              {place.promotion_type === 1 && (
                <span className="badge badge-pill text-white bg-tunagate-gradation" style={{display: 'inline'}}>
                  予約特典
                </span>
              )}
              {place.name}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SectionLowerBanners;